import { apiClient } from '../utils/api';

export async function getFormByFormId(id, appointmentChannelId = null, path = null) {
    if (id == null || id === '') {
        return Promise.reject(new Error('Form ID is required. Pass form_id (or form) in the URL, e.g. ?form_id=YOUR_FORM_ID'));
    }
    const params = new URLSearchParams();
    if (appointmentChannelId) params.set('appointment_channel_id', appointmentChannelId);
    if (path) params.set('path', path);
    const qs = params.toString();
    return await apiClient.GET(`api/channels/widget/${id}${qs ? '?' + qs : ''}`);
}
